/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.links-menu-extension.alignment.title': '對齊',
  'company-hub.links-menu-extension.all.borders.label-text': '每一邊',
  'company-hub.links-menu-extension.background.color': '背景顏色',
  'company-hub.links-menu-extension.background.title': '背景',
  'company-hub.links-menu-extension.border.color': '邊框顏色',
  'company-hub.links-menu-extension.border.position': '邊框位置',
  'company-hub.links-menu-extension.bottom.border.label-text': '底部邊框',
  'company-hub.links-menu-extension.center.option': '置中',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': '新增重要連結',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': '連結',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': '將相關連結分成一組',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text': '您已達到巢狀層級的數量上限。',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': '選單',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': '取消',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': '刪除',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    '此動作將刪除此項目和所有巢狀項目。',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': '刪除項目',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': '新增子項目',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': '刪除項目',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': '編輯屬性',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': '向下移動',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': '向上移動',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': '開啟連結',
  'company-hub.links-menu-extension.config-panel.items.label': '項目',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    '您已達到可新增至連結選單的項目數量上限。',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': '新項目',
  'company-hub.links-menu-extension.config-panel.preamble': '新增連結並使用子選單加以整理。{linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': '進一步了解連結選單',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link': '新增連結並使用子選單加以整理。',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': '取消',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': '確認',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': '請填寫此欄位。',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': '顯示文字',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': '項目名稱',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': '確認',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': '更多',
  'company-hub.links-menu-extension.config-panel.styles.label': '樣式',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    '您已達到可新增至連結選單的項目數量上限。',
  'company-hub.links-menu-extension.config-panel.title': '連結選單',
  'company-hub.links-menu-extension.fixed.option': '固定在頂部',
  'company-hub.links-menu-extension.left.option': '靠左',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': '更多',
  'company-hub.links-menu-extension.manifest.extension-description': '將多個連結和子選單新增至「公司中心」',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': '連結選單',
  'company-hub.links-menu-extension.manifest.extension-title': '連結選單 [新功能]',
  'company-hub.links-menu-extension.manifest.first-default-item': '關於我們',
  'company-hub.links-menu-extension.manifest.nested-default-item': '團隊 1',
  'company-hub.links-menu-extension.manifest.second-default-item': '福利',
  'company-hub.links-menu-extension.manifest.third-default-item': '團隊',
  'company-hub.links-menu-extension.no.border.label-text': '無',
  'company-hub.links-menu-extension.right.option': '靠右',
  'company-hub.links-menu-extension.section.collapse.label': '摺疊區段',
  'company-hub.links-menu-extension.section.expand.label': '展開區段',
  'company-hub.links-menu-extension.selected.state.color': '選取的狀態顏色',
  'company-hub.links-menu-extension.text.color': '文字顏色',
  'company-hub.links-menu-extension.text.title': '文字',
};
